<template>
    <div class="container">
        <div class="max-w-md">
            <el-card class="bg-white">
                <h1 class="text-xl">智慧实验室签到</h1>
                <p class="text-gray">请点击下方按钮开始签到流程</p>
                <el-button type="primary" class="w-full" @click="startScan">
                    <i class="el-icon-scanner mr-2"></i>开始签到
                </el-button>
            </el-card>

            <!-- <div class="mt-8 text-center text-sm text-gray-400">
                <p>© 2026 扫码签到系统</p>
            </div> -->
        </div>
    </div>
</template>

<script>
export default {
    name: "qr_code",
    data() {
        return {
            code_key: '',
            identifier: '', // 用户标识
        }
    },
    components: {},
    created() {
        // 获取扫码密钥
        this.code_key = this.$route.query.code_key;
        this.identifier = this.$route.query.identifier;
    },
    methods: {
        startScan() {
            // 模拟扫码操作，实际项目中可以使用二维码扫描库
            console.log('开始扫码');
            // 扫码完成后跳转到学工号输入页
            // 验证成功，跳转到成功页面
            this.$router.push({
                path: '/qrCode/input',
                query: {
                    code_key: this.code_key,
                    identifier: this.identifier,
                }
            });
        }
    },
};
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100%;
    display: flex;
    overflow: hidden;
    background: #eff6ff;
    justify-content: center;
    flex-direction: column;

    .max-w-md {
        display: flex;
        flex-wrap: nowrap;
        flex-direction: column;
        justify-content: center;
        width: 90%;
        margin: 0 auto;
    }

    .text-xl {
        font-size: 25px;
        color: rgb(37 99 235);
    }

    .text-gray {
        text-align: center;
        color: rgb(107 114 128);
    }

    .w-full {
        margin-top: 50px;
        width: 60%;
        background: rgb(37, 99, 235);
        height: 50px;
    }
}

/* 自定义样式 */
::v-deep .el-card__body {
    text-align: center;
}

.el-card {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
}

.el-button {
    border-radius: 12px;
    padding: 12px 0;
    font-size: 16px;
}
</style>